import TextContentTranslationModelBase from '../_generated/modelBases/text-content-translation-model-base';

export default class TextContentTranslationModel extends TextContentTranslationModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
